// AUTO-GENERATED by scripts/select-page-mode.js — do not edit directly.
// Source: src/pageModules/DynamicPage.ssg.tsx (RENDER_MODE=<unset>)

import { DynamicPage } from '@/pageModules/DynamicPage';
import {
  findAllPageSlugPaths,
  loadPageProps,
} from '@/pageModules/loadPageProps';
import { GetStaticProps, type GetStaticPaths } from 'next';

export const getStaticProps: GetStaticProps = async (context) =>
  loadPageProps(context?.params?.slug);

export const getStaticPaths: GetStaticPaths = async () =>
  findAllPageSlugPaths();

export default DynamicPage;
